var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01208 0.900972C3.21819 0.694862 3.21819 0.360692 3.01208 0.154582C2.80597 -0.0515277 2.4718 -0.0515273 2.26569 0.154583L0.154582 2.2657C0.139347 2.28094 0.125139 2.29701 0.112004 2.3138C0.0509897 2.39174 0.0114093 2.48726 0.00213175 2.59149C0.000716548 2.60719 0 2.62301 0 2.6389C0 2.75354 0.0372998 2.86433 0.105179 2.95506C0.120178 2.97511 0.13667 2.99418 0.154583 3.01209L2.26569 5.1232C2.4718 5.32931 2.80598 5.32931 3.01208 5.12319C3.21819 4.91708 3.21819 4.58291 3.01208 4.3768L1.80194 3.16667H5.4537C8.66002 3.16667 11.2593 5.7659 11.2593 8.97222C11.2593 9.26371 11.4956 9.5 11.787 9.5C12.0785 9.5 12.3148 9.26371 12.3148 8.97222C12.3148 5.18293 9.24299 2.11111 5.4537 2.11111H1.80195L3.01208 0.900972Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.2ec78517990c65dfbbfdac9c48031606.svg";
export { ForwardRef as ReactComponent };